export default __webpack_public_path__ + "static/media/pictogramBeaconRenovations128.65e2a7c7.svg";